import type { JSX } from '@familyjs/core/components';
import { FmlBreadcrumb as FmlBreadcrumbCmp } from '@familyjs/core/components/fml-breadcrumb.js';
import { FmlButton as FmlButtonCmp } from '@familyjs/core/components/fml-button.js';
import { FmlCard as FmlCardCmp } from '@familyjs/core/components/fml-card.js';
import { FmlFabButton as FmlFabButtonCmp } from '@familyjs/core/components/fml-fab-button.js';
import { FmlItemOption as FmlItemOptionCmp } from '@familyjs/core/components/fml-item-option.js';
import { FmlItem as FmlItemCmp } from '@familyjs/core/components/fml-item.js';
import { FmlRouterLink as FmlRouterLinkCmp } from '@familyjs/core/components/fml-router-link.js';

import { createRoutingComponent } from './createRoutingComponent';
import type { HrefProps } from './hrefprops';

export const FmlRouterLink = /*@__PURE__*/ createRoutingComponent<
  HrefProps<JSX.FmlRouterLink>,
  HTMLFmlRouterLinkElement
>('fml-router-link', FmlRouterLinkCmp);

export const FmlButton = /*@__PURE__*/ createRoutingComponent<HrefProps<JSX.FmlButton>, HTMLFmlButtonElement>(
  'fml-button',
  FmlButtonCmp
);

export const FmlCard = /*@__PURE__*/ createRoutingComponent<HrefProps<JSX.FmlCard>, HTMLFmlCardElement>(
  'fml-card',
  FmlCardCmp
);

export const FmlFabButton = /*@__PURE__*/ createRoutingComponent<HrefProps<JSX.FmlFabButton>, HTMLFmlFabButtonElement>(
  'fml-fab-button',
  FmlFabButtonCmp
);

export const FmlItem = /*@__PURE__*/ createRoutingComponent<HrefProps<JSX.FmlItem>, HTMLFmlItemElement>(
  'fml-item',
  FmlItemCmp
);

export const FmlItemOption = /*@__PURE__*/ createRoutingComponent<
  HrefProps<JSX.FmlItemOption>,
  HTMLFmlItemOptionElement
>('fml-item-option', FmlItemOptionCmp);

export const FmlBreadcrumb = /*@__PURE__*/ createRoutingComponent<
  HrefProps<JSX.FmlBreadcrumb>,
  HTMLFmlBreadcrumbElement
>('fml-breadcrumb', FmlBreadcrumbCmp);
